import React, { useState, useRef } from "react";
import Card from "components/card";
import { Gift, Sparkles } from "lucide-react";
import StoreAction from "./StoreAction";
import StoreModal from "./StoreModal";
import SearchBar from "components/search/SearchBar";
import { STORE_CATEGORIES } from "variables/constants";
import CategoryFilter from "./CategoryFilter";
import VoucherGrid from "./VoucherGrid";
import { vouchers } from "./Vouchers";

const HyvidStore = () => {
    const [category, setCategory] = useState("all");
    const [searchTerm, setSearchTerm] = useState("");
    const [cartItems, setCartItems] = useState([]);

    const voucherGridRef = useRef(null);

    const handleSearch = ({ keyword }) => {
        setSearchTerm(keyword || "");
    };

    const handleAddToCart = (voucher) => {
        setCartItems(prev => {
        const existing = prev.find(item => item.voucher.value === voucher.value);
            if (existing) {
                return prev.map(item =>
                item.voucher.value === voucher.value
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
                );
            } else {
                return [...prev, { voucher, quantity: 1 }];
            }
        });
    };

    const handleRemoveFromCart = (voucher) => {
        setCartItems(prev => prev.filter(item => item.voucher.value !== voucher.value));
    };

    const handleUpdateQuantity = (voucher, delta) => {
        setCartItems(prev => prev
        .map(item =>
            item.voucher.value === voucher.value
            ? { ...item, quantity: Math.max(1, item.quantity + delta) }
            : item
        )
        .filter(item => item.quantity > 0)
        );
    };

    const filteredVouchers = vouchers.filter((v) => {
        const matchesCategory = category === "all" || v.category === category;
        const matchesSearch =
        v.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        v.category.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesCategory && matchesSearch;
    });

    const scrollToVouchers = () => {
        if (voucherGridRef.current) {
            voucherGridRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <Card className="space-y-6">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-[28px] font-bold label-gradient emerald flex items-center gap-3">
                        <Gift className="w-8 h-8 text-emerald-600" />
                        HyvidStore
                    </h1>
                    <p className="text-[14px] text-slate-700 mt-1">
                        Redeem amazing gift vouchers with your Hyvid Points
                    </p>
                </div>
                <div className="flex items-center gap-3">
                    <div className="text-slate-900 flex flex-col gap-6 rounded-xl border-2 border-emerald-200 bg-gradient-to-r from-emerald-50 to-purple-50">
                        <div className="pb-6 p-3 flex items-center gap-2">
                            <Sparkles className="w-5 h-5 text-emerald-600" />
                            <div>
                                <p className="text-[10px] text-slate-700">
                                    Your Points
                                </p>
                                <p className="font-bold text-emerald-600">
                                    2,400
                                </p>
                            </div>
                        </div>
                    </div>
                    <StoreAction cartItems={cartItems} setCartItems={setCartItems}>
                        <StoreModal 
                            cartItems={cartItems} 
                            setCartItems={setCartItems}
                            onRemove={handleRemoveFromCart}
                            onUpdateQuantity={handleUpdateQuantity}
                        />
                    </StoreAction>
                </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
                <SearchBar
                    placeholder="Search vouchers by name, brand, or category..."
                    searchHandler={handleSearch}
                />
            </div>
            <CategoryFilter
                categories={STORE_CATEGORIES}
                value={category}
                onChange={setCategory}
                onBrowseAll={scrollToVouchers}
            />
            <div ref={voucherGridRef}>
                <VoucherGrid 
                    vouchers={filteredVouchers} 
                    onAdd={handleAddToCart}
                />
            </div>
        </Card>
    )
};
export default HyvidStore;